export const WIDGET_REFRESH_STORAGE_KEY = 'WIDGET_REFRESH_STORAGE_KEY';
export const WIDGET_SUPPORT_CHATBOT = 'WIDGET_SUPPORT_CHATBOT';
export const WIDGET_SDK_CHANNEL = 'WIDGET_SDK_CHANNEL';
export const TOOLTIP_CLOSE_TIMEOUT = 48 * 60 * 60 * 1000; // 48h

export let WidgetEvents = /*#__PURE__*/function (WidgetEvents) {
  WidgetEvents["NEW"] = "new";
  WidgetEvents["LOG_MESSAGE"] = "log_message";
  WidgetEvents["UPDATE_LOAD_PAGE_URL"] = "load_page_url";
  WidgetEvents["UPDATE_DEALER_OFFER_PARAMS"] = "update_dealer_offer_params";
  WidgetEvents["UPDATE_ARTICLE_URI"] = "update_article_uri";
  WidgetEvents["UPDATE_ARTICLE_ID"] = "update_article_id";
  WidgetEvents["UPDATE_ORIG_PARAMS"] = "updateOrigParams";
  WidgetEvents["GET_ORIG_PARAMS_RESPONSE"] = "getOrigParamsResponse";
  WidgetEvents["SET_INITIAL_PARAMS"] = "setInitialParams";
  WidgetEvents["CONTEXT_CHANGE"] = "contextChange";
  WidgetEvents["CALL_SDK_METHOD_REQUEST"] = "callSdkMethodRequest";
  WidgetEvents["CALL_SDK_METHOD_RESPONSE"] = "callSdkMethodResponse";
  WidgetEvents["CALL_INTERNAL_HANDLER_REQUEST"] = "callInternalSdkMethodRequest";
  WidgetEvents["CALL_INTERNAL_HANDLER_RESPONSE"] = "callInternalSdkMethodResponse";
  WidgetEvents["CALL_INTERNAL_SDK_METHOD_REQUEST"] = "callInternalSdkMethodRequest";
  WidgetEvents["CALL_INTERNAL_SDK_METHOD_RESPONSE"] = "callInternalSdkMethodResponse";
  WidgetEvents["OPEN_CHATBOT_PAGE"] = "openChatbotPage";
  WidgetEvents["OPEN_SEARCH_PAGE"] = "openSearchPage";
  WidgetEvents["TOGGlE_WIDGET_EXPANDED"] = "toggleWidgetExpanded";
  WidgetEvents["WIDGET_MOBILE_VIEW_CHANGED"] = "widgetMobileViewChanged";
  WidgetEvents["UPDATE_WIDGET_URL"] = "updateWidgetUrl";
  WidgetEvents["WIDGET_SIZE_CHANGE"] = "widgetSizeChange";
  WidgetEvents["OPEN_HOME_PAGE"] = "openHomePage";
  WidgetEvents["SESSION_REFRESH"] = "sessionRefresh";
  return WidgetEvents;
}({});
export let ChatbotEvents = /*#__PURE__*/function (ChatbotEvents) {
  ChatbotEvents["CLICK_EDITOR_LINK"] = "clickEditorLink";
  ChatbotEvents["UPDATE_WIDGET_URL"] = "updateWidgetUrl";
  return ChatbotEvents;
}({});
export let Platform = /*#__PURE__*/function (Platform) {
  Platform["UNKNOWN"] = "UNKNOWN";
  Platform["DESKTOP"] = "DESKTOP";
  Platform["MOBILE"] = "MOBILE";
  Platform["APP"] = "APP";
  return Platform;
}({});
export let Editor = /*#__PURE__*/function (Editor) {
  Editor["UNKNOWN"] = "UNKNOWN";
  Editor["EDITOR_X"] = "EDITOR_X";
  Editor["EDITOR"] = "EDITOR";
  Editor["ADI"] = "ADI";
  return Editor;
}({});

// merge it with OrigParams

export let WidgetSize = /*#__PURE__*/function (WidgetSize) {
  WidgetSize[WidgetSize["Default"] = 0] = "Default";
  WidgetSize[WidgetSize["Maximized"] = 1] = "Maximized";
  return WidgetSize;
}({});

// TODO: move it widget-common
//# sourceMappingURL=widgetMessaging.js.map